import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      header: _ctx.title,
      style: _ctx.workspaceWarningDialogDescriptor.dialog.style,
      visible: _ctx.visible,
      modal: true,
      class: "p-fluid kn-dialog--toolbar--primary",
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Message, {
          class: "p-m-2",
          severity: "warn",
          closable: false,
          style: _ctx.workspaceWarningDialogDescriptor.styles.message
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.warningMessage), 1)
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["header", "style", "visible"])
  ]))
}